// jQuery wrapper
(function($) {

	/**
	 ** Document ready
	 **/
	$(document).ready(function(){

		$('body').addClass('active');


		// WOW.js for animations
		new WOW().init();


		// Header bar scrolled
		scrollbarState();

		// Pages with white header
		if ( $('body').hasClass('blog') || $('body').hasClass('single-post') || $('body').hasClass('category') || $('body').hasClass('date') || $('body').hasClass('search') || $('body').hasClass('single-team_member') || $('body').hasClass('single-condition') || $('body').hasClass('page-template-page-policy')) {
			$('body').addClass('white-header');
		}


		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function(event) {
			event.preventDefault();
			var target = $(this).data('target');
			var headerHeight = $('#site-header').outerHeight();
			var scrollPosition = $(target).offset().top - headerHeight;
			var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
	            scrollTop: scrollPosition
	        }, 1000);
		});


		// Accordion list (FAQs / Features)
		if ($('.accordion-list').length > 0) {
			$('.accordion-list .answer:not(.active)').hide();

	        var allPanels = $('.accordion-list .answer');

	        $('.accordion-list .question').click( function() {
	            var target = $(this).next();

	            // console.log(targetParent);

	            if ( $(target).hasClass('active') ) {
	                $(this).removeClass('current');
	                $(target).removeClass('active').slideUp(250);
	            } else {
	                $('.accordion-list .question').removeClass('current');
	                $(allPanels).removeClass('active').slideUp(250);
	                $(this).addClass('current');
	                $(target).addClass('active').slideDown(250);
	            }

	            // Prevent default 'link' behaviour
	            return false;
	        });
	    }


	    /*
	    // News - Toggle filter on mobile
	    if ( $('#filter-wrap').length > 0 ) {
	    	$('.filter-toggle').on('click', function() {
	    		$(this).toggleClass('active');
	    		$('#filter').toggleClass('open');
	    	})
	    };

	    // Dropkick - custom dropdown/select in Forms
		if ( $('.form-wrap select').length > 0 ) {
		    $('.form-wrap select').dropkick({
		        mobile: true
		    });
		}
		*/

		// Dropkick - custom dropdown/select on News Filter
		if ( $('#filter select').length > 0 ) {
		    $('#filter select').dropkick({
		        mobile: true
		    });
		}


		// News - Toggle filter on mobile
	    if ( $('#filter-wrap').length > 0 ) {
	    	$('.filter-toggle').on('click', function() {
	    		$(this).toggleClass('active');
	    		$('#filter').toggleClass('open');
	    	})
	    };


	    /***
		 * Menus
		 ***/

		// Desktop Menu
		$('.desktop-menu .hasSub > a, #footer-menu .hasSub > a').click(function(event) {
			event.preventDefault();

			var target = '#desktop-submenu ' + $(this).attr('href');

			$('.card .hasSub a').not(this).removeClass('show');

			$('.sub .card').removeClass('show animated fadeIn');

			if ($(this).hasClass('show')) {
				$('#desktop-submenu').removeClass('open');
				$('body').removeClass('dt-menu-open');
				$(target).removeClass('show animated fadeIn');
				$(this).removeClass('show');
			} else {
				$('#desktop-submenu').addClass('open');
				$('body').addClass('dt-menu-open');
				$(target).addClass('show animated fadeIn');
				$('.desktop-menu .hasSub a, #footer-menu .hasSub > a').removeClass('show');
				$(this).addClass('show');
			}
		});
		$('#desktop-submenu .close-sub').click(function() {
			event.preventDefault();

			var target = '#desktop-submenu ' + $(this).attr('href');
			$('.nav-link.active').removeClass('active');
			$('.desktop-menu .hasSub a, #footer-menu .hasSub > a').removeClass('show');
			$('#desktop-submenu').removeClass('open');
			$(target).addClass('fadeOut');
			// setTimeout(function(){
			  	$(target).removeClass('fadeOut fadeIn show animated');
			// }, 0);
			$('body').removeClass('dt-menu-open');
		});

		// Mobile Menu - Hamburger
		$('.hamburger').click(function() {
			$('.card .hasSub a').removeClass('active');
			$('.card .hasChild a').removeClass('active');
			$('.sub .card').removeClass('show animated fadeIn');
			$('.children .card').removeClass('show animated fadeIn');

			$('body').toggleClass('mob-menu-open');
			$(this).toggleClass('is-active');
			var target = $(this).data('target');
			// console.log(target);
			// $('body').toggleClass('modal-open');
			$(target).toggleClass('open');
			// $('#mobile-menu-wrap').scrollTop(0);
		});

		// Mobile Menu - First Level
		$('#mobile-menu .hasChild > a').click(function(event) {
			event.preventDefault();

			$(this).siblings().toggleClass('open');
			$(this).toggleClass('show');
		});

		// Mobile Menu - Don't close dropdown on link click
		$('#mobile-menu .dropdown-menu .dropdown-item').click( function(e) {
			// console.log('dropdown link clicked');
			e.stopPropagation();
		});



	    // Featured Treatments / Spotlight
	    // Desktop
	    if ($('#treatment-cards').length > 0) {
	    	$('#treatment-cards .card .trigger').click(function() {
	        	var allCards = $('#treatment-cards .card');
	        	var current = $(this).parent();

	        	if ( current.hasClass('active') ) {
	        		// Do nothing if hovering active card
	        	} else {
	        		allCards.removeClass('active');
	        		$(current).addClass('active');

	        	}
	        });

	    	$('.ft-btn').on('click', function(event) {
				event.preventDefault();

				var target = $(this).data('target'),
					total = $('span.total').data('total'),
					currentSlide = $('#treatment-cards .card.active').data('order');

	    		// If button active
	    		if( $(this).hasClass('ft-next') ) {

    				if(currentSlide == total) {
    					// Reset count if last slide
						var nextSlide = 1;
					} else {
						// Go to next slide
						var nextSlide = currentSlide + 1;
					}

					$('#treatment-cards .card').removeClass('active');
					$('#treatment-cards .card[data-order="' + nextSlide + '"]').addClass('active');

	    		} else {

	    			if(currentSlide == 1) {
    					// Reset count if last slide
						var prevSlide = total;
					} else {
						// Go to next slide
						var prevSlide = currentSlide - 1;
					}

					$('#treatment-cards .card').removeClass('active');
					$('#treatment-cards .card[data-order="' + prevSlide + '"]').addClass('active');

	    		}
	    	});
		}

		// Mobile
		if ($('#treatment-cards').length > 0) {

			// Carousel
			$('.ft-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: false,
				centerMode: false,
				prevArrow: $('.ft-prev-mob'),
				nextArrow: $('.ft-next-mob'),
			});
		}


	    /***
		 * Carousels
		 ***/

		// Awards
		if ($('.awards-carousel').length > 0) {
			$('.awards-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: false,
				infinite: true,
				centerMode: false,
				// asNavFor: '.treatment-counter',
			});
		}

		// As Seen In / Media
		if ($('.seen-in-carousel').length > 0) {
			$('.seen-in-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.seen-in-prev'),
				nextArrow: $('.seen-in-next'),
			});
		}

		// Accreditations Carousel
		if ($('.accreditations-carousel').length > 0) {
			$('.accreditations-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 0,
				speed: 8000,
				cssEase: 'linear',
				pauseOnHover: false,
				pauseOnFocus: false,
				draggable: false,
				swipe: false,
				arrows: false,
				infinite: true,
				variableWidth: true,
				centerMode: false,
			});
		}

		// News
		if ($('.news-carousel').length > 0) {
			$('.news-carousel').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.news-prev'),
				nextArrow: $('.news-next'),

				responsive: [
		    		{
		    			breakpoint: 1140,
		    			settings: {
							slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 992,
		    			settings: {
							slidesToShow: 1,
		    			}
		    		},
		    	]
			});
		}

		// Team
		if ($('.team-carousel').length > 0) {
			$('.team-carousel').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.team-prev'),
				nextArrow: $('.team-next'),

				responsive: [
		    		{
		    			breakpoint: 1140,
		    			settings: {
							slidesToShow: 2,
		    			}
		    		},
		    		{
		    			breakpoint: 992,
		    			settings: {
							slidesToShow: 1,
		    			}
		    		},
		    	]
			});
		}

		// At a Glance
		if ($('.glance-mob-carousel').length > 0) {
			$('.glance-carousel').slick({
				slidesToShow: 5,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.glance-prev'),
				nextArrow: $('.glance-next'),
			});

			$('.glance-mob-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.glance-mob-prev'),
				nextArrow: $('.glance-mob-next'),
			});
		}

		// Before & After
		if ($('.before-after-carousel').length > 0) {
			$('.before-after-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.ba-prev'),
				nextArrow: $('.ba-next'),
			});
		}

		// Treatments - Mobile
		if ($('.treatments-mob-carousel').length > 0) {
			$('.treatments-mob-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.treatments-mob-prev'),
				nextArrow: $('.treatments-mob-next'),
			});
		}
		// Treatments - Desktop
		if ($('.treatments-carousel').length > 0) {
			$('.treatments-carousel').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.treatments-prev'),
				nextArrow: $('.treatments-next'),

				responsive: [
		    		{
		    			breakpoint: 992,
		    			settings: {
							slidesToShow: 3,
		    			}
		    		},
		    		{
		    			breakpoint: 768,
		    			settings: {
							slidesToShow: 1,
		    			}
		    		},
		    	]
			});
		}

		// Conditions - Mobile
		if ($('.conditions-mob-carousel').length > 0) {
			$('.conditions-mob-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.conditions-mob-prev'),
				nextArrow: $('.conditions-mob-next'),
			});
		}
		// Conditions - Desktop
		if ($('.conditions-carousel').length > 0) {
			$('.conditions-carousel').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.conditions-prev'),
				nextArrow: $('.conditions-next'),

				responsive: [
		    		{
		    			breakpoint: 992,
		    			settings: {
							slidesToShow: 3,
		    			}
		    		},
		    		{
		    			breakpoint: 768,
		    			settings: {
							slidesToShow: 1,
		    			}
		    		},
		    	]
			});
		}

		// Videos
		if ($('.video-carousel').length > 0) {
			// Mobile
			$('.video-mob-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.video-mob-prev'),
				nextArrow: $('.video-mob-next'),
			});
			// Desktop
			$('.video-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.video-prev'),
				nextArrow: $('.video-next'),
			});
		}


		// Video modal toggle open/closed
	    $('.video-toggle').click( function() {
	    	var target = $(this).data('target');
	    	$(target).modal('toggle');
	    });
    	// Video modal - Empty player on close
        $('.close-video').click( function() {
        	$('.video-container').empty();
        });


        // Set Cookie function
        function createCookie(name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else var expires = "";
            document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
        }
        // Privacy Policy Cookies
        function cookiesPolicyBar(){
            // Check cookie
            if ($.cookie('blowClinicPrivacy') != "accepted") $('#cookie-notification').fadeIn();

            //Assign cookie on click
            $('#cookie-notification a, #cookie-notification button').on('click',function(){
                createCookie("blowClinicPrivacy", "accepted", 90); // Cookie expires in 90 days
                $('#cookie-notification').fadeOut();
            });
        }
        // Run cookie policy function
        cookiesPolicyBar();




    }); // End Document Ready


    // On load
	$(window).on('load', function() {

		// Carousel Equal Heights
	    carouselEqualHeights();

	    /***
		 * Parallax
		 ***/
		const para_up = document.getElementsByClassName('para-up');
		const para_up_min = document.getElementsByClassName('para-up-min');
		const para_down = document.getElementsByClassName('para-down');
		const para_down_min = document.getElementsByClassName('para-down-min');

		new simpleParallax(para_up, {
			//delay: .25,
			orientation: 'up',
			scale: 1.15,
			overflow: true,
			transition: 'cubic-bezier(0,0,0,1)',
			// maxTransition: 80
		});
		new simpleParallax(para_up_min, {
			//delay: .25,
			orientation: 'up',
			scale: 1.05,
			overflow: true,
			transition: 'cubic-bezier(0,0,0,1)',
			// maxTransition: 80
		});

		new simpleParallax(para_down, {
			//delay: .25,
			orientation: 'down',
			scale: 1.15,
			overflow: true,
			transition: 'cubic-bezier(0,0,0,1)',
			// maxTransition: 80
		});
		new simpleParallax(para_down_min, {
			//delay: .25,
			orientation: 'down',
			scale: 1.05,
			overflow: true,
			transition: 'cubic-bezier(0,0,0,1)',
			// maxTransition: 80
		});

	});


	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});


	// On Resize
	$(window).on('resize', function () {

		// Carousel Equal Heights
	    carouselEqualHeights();

	});


	// Header bar scrolled
	function scrollbarState() {
    	var navHeight = $('#site-header').outerHeight();

		if ( $(document).scrollTop() > navHeight ) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
    		$('body').removeClass('scrolled');
    		$('#site-header').removeClass('is-scrolled');
		}
	}


	// Carousel - Equal heights
	function carouselEqualHeights() {
		$('.carousel.equal').on('setPosition', function () {
			$(this).find('.slick-slide').height('auto');
			var slickTrack = $(this).find('.slick-track');
			var slickTrackHeight = $(slickTrack).height();
			$(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
		});
	}

	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();
		$('#cta-popup').removeClass('active');
		// Set session cookie (no expiry = removed on browser close)
		setCookie('ctaPopupDismissed', 'true');
	});

// end jQuery wrapper
})(jQuery);